// Hooks
import { useProtectedContent } from "../../hooks/useProtectedContent";
// MUI
import Divider from "@mui/material/Divider";
// import Highlights from "./Highlights";
import FAQ from "./FAQ";
import ChatPanel from "./ChatPanel";

export function Support() {
  return (
    <>
      {/* <Divider />
      <Highlights /> */}
      <ChatPanel />
      <Divider sx={{ my: 4 }} />
      {/* {useProtectedContent("staffRequestCreate") ? <FAQStaff /> : <FAQ />} */}
      <FAQ staff={useProtectedContent("staffRequestCreate")} />
    </>
  );
}
